import { Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { DataConnectorContext, DataConnectorContextpayload } from '../../../context/dataConnectorContext';
import EmptyState from '../../global/emptyState';
import emptyCustomApiImage from "../../../assets/images/customApi/empty_custom_api.png";
import GlobalButton from '../../utility/globalButton/button';
import IconsColor from '../../utility/iconsColor';
import globalStyles from "../../../assets/styles/global.module.scss";
import styles from "../../../assets/styles/componentStyles/customApiStyles/customApiStyle.module.scss";
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { GlobalTable } from '../../utility/globalTable';
import CustomApiTable from './customApiTable';
import { useNavigate } from 'react-router-dom';
import { dataConnectorList } from '../../../models/axiosModel';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import GlobalPopUp from '../../utility/globalPopUp';
import AssignChatbotPopup from './assignChatbotPopup';
import AssignVoiceAgentPopup from './assignVoiceAgentPopup';
import { hasCustomAPIPageManageAccess } from '../../../utils/constants';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

const CustomApiList = () => {

    const { dataConnectorList, getChatbotDataConnectorList, deleteDataConnector } = useContext(DataConnectorContext) as DataConnectorContextpayload;
    const { setFlagLoading, handleError, apiRoutesPermissionAssignment, userDetail} = useContext(UserContext) as UserContextPayload;
    
    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
    const [showAssignedChatbotPopup, setShowAssignedChatbotPopup] = useState<boolean>(false);
    const [showAssignedVoiceAgentPopup, setShowAssignedVoiceAgentPopup] = useState<boolean>(false);
    const [selectedDataConnector, setSelectedDataConnector] = useState<dataConnectorList | null>(null);

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const navigate = useNavigate();    

    const deleteDataConnectorApiCall = async (chatbot_data_connector_id: number) => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        const res = await deleteDataConnector(chatbot_data_connector_id.toString());
        // getChatbotDataConnectorList();
        if (!(res.status)) {
            handleError(res);
        } else {
            showSuccess("Data Connector Deleted Successfully")
            getChatbotDataConnectorList();
        }
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    } 

    const getChatbotDataConnectorListApiCall = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const res = await getChatbotDataConnectorList();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    useEffect(() => {
        (async () => {
            await getChatbotDataConnectorListApiCall();
        })();
    }, []);

    return (
        <>
            <Grid item className={`${globalStyles.fullwidth} ${styles.mainCustomAPIGridItem}`}>
                <Grid container direction={"column"} gap={"24px"}>
                    {!dataConnectorList ?
                        <> </>
                        :
                        dataConnectorList.length === 0 ? 
                                <Grid item className={`${globalStyles.fullwidth}`}>
                                    <EmptyState
                                        height={'calc(100vh - 125px)'}
                                        pageIcon={<img alt="icon" src={emptyCustomApiImage} className={`${styles.emptyCustomAPIImage}`} />}
                                        pageSubText={"No Custom API Created Yet"}
                                        primaryActionBtn={
                                            <>
                                                {hasCustomAPIPageManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                                    <GlobalButton
                                                        buttonText={"New Custom API"}
                                                        className='primaryButtonStyle'
                                                        sx={{ width: "170px" }}
                                                        startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor="#fff" />}
                                                        onClick={() => navigate(`/customAPI/createCustomAPI`)}
                                                    />
                                                }
                                            </>
                                        }
                                    />
                                </Grid>
                            :
                            <>
                                <CustomApiTable
                                    setShowDeleteConfirmation={setShowDeleteConfirmation}
                                    setSelectedDataConnector={setSelectedDataConnector} 
                                    setShowAssignedChatbotPopup={setShowAssignedChatbotPopup}
                                    setShowAssignedVoiceAgentPopup={setShowAssignedVoiceAgentPopup}
                                />
                            </>
                    }
                </Grid>

            {
                showDeleteConfirmation &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete "${selectedDataConnector?.data_connector_functions?.data_connector_function_name}" custom API`}
                    open={showDeleteConfirmation}
                    onClose={() => setShowDeleteConfirmation(false)}
                    onDelete={() => {
                        if (selectedDataConnector) {
                            deleteDataConnectorApiCall(selectedDataConnector.chatbot_data_connector_id)
                        }
                        setShowDeleteConfirmation(false)
                    }}
                />
            }

            {showAssignedChatbotPopup &&
                <GlobalPopUp
                    open={showAssignedChatbotPopup}
                    onClose={() => setShowAssignedChatbotPopup(false)}
                    handleClose={() => setShowAssignedChatbotPopup(false)}
                    flagShowCloseIcon={true}
                    paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "700px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "750px"}
                    borderRadius='10px'
                    titlePadding='0px'
                >
                    <AssignChatbotPopup
                        selectedDataConnector={selectedDataConnector as dataConnectorList}
                        setShowAssignedChatbotPopup={setShowAssignedChatbotPopup}
                    />
                </GlobalPopUp>
            }

            {showAssignedVoiceAgentPopup &&
                <GlobalPopUp
                    open={showAssignedVoiceAgentPopup}
                    onClose={() => setShowAssignedVoiceAgentPopup(false)}
                    handleClose={() => setShowAssignedVoiceAgentPopup(false)}
                    flagShowCloseIcon={true}
                    paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "700px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "750px"}
                    borderRadius='10px'
                    titlePadding='0px'
                >
                    <AssignVoiceAgentPopup
                        selectedDataConnector={selectedDataConnector as dataConnectorList}
                        setShowAssignedVoiceAgentPopup={setShowAssignedVoiceAgentPopup}
                    />
                </GlobalPopUp>
            }
            </Grid>
        </>
    )
}

export default CustomApiList
